<template>
  <header class="analysis-header">
    <Button v-if="menuButton" class="menu" icon @click="toggleMenu"><MenuIcon /></Button>
    <h2 class="title">{{ title }}</h2>
    <div class="right">
      <slot>
        <Button v-if="button" flat :disabled="disabled" class="download" @click="downloadCSV">
          <DownloadIcon />CSV
        </Button>
      </slot>
    </div>
  </header>
</template>

<script>
import { format } from 'date-fns'
import { mapState, mapGetters } from 'vuex'
import Button from '@/components/atoms/Button'
import MenuIcon from '@/components/icons/menu'
import DownloadIcon from '@/components/icons/download'

export default {
  name: 'AnalysisHeader',
  components: {
    Button,
    MenuIcon,
    DownloadIcon,
  },
  props: {
    /** 開閉ボタン */
    menuButton: { type: Boolean, default: true },
    /** ページの名前 */
    pageName: { type: String, default: '' },
    /** ページタイトル */
    title: { type: String, default: '' },
    /** カレントページキー */
    current: String,
    /** ダウンロードボタンの表示制御 */
    button: { type: Boolean, default: true },
    /** ダウンロードボタンの活性制御 */
    disabled: { type: Boolean },
  },
  computed: {
    ...mapState({
      csv: state => state.analysis.csv,
      menuOpen: state => state.analysis.menuOpen,
    }),
    ...mapGetters({
      blob: 'analysis/csv/blob',
      query: 'analysis/aggregate/query',
    }),
  },
  methods: {
    toggleMenu() {
      this.$store.commit('analysis/menu', !this.menuOpen)
    },
    async downloadCSV() {
      if (await this.$store.dispatch('analysis/csv/get', { query: this.query, target: this.pageName })) {
        const { startTerm, endTerm } = this.query
        const link = document.createElement('a')
        const href = window.URL.createObjectURL(this.blob)
        link.href = href
        link.download = `${this.title}_${
          startTerm === endTerm
            ? format(endTerm, 'YYYYMM')
            : `${format(startTerm, 'YYYYMM')}〜${format(endTerm, 'YYYYMM')}`
        }.csv`
        link.click()
        // WebKitBlobResourceエラー1 防止
        setTimeout(() => {
          window.URL.revokeObjectURL(href)
        }, 200)
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.analysis-header {
  align-items: center;
  border-bottom: solid 1px var(--border-color);
  display: grid;
  grid-auto-flow: column;
  height: 56px;
  padding: 0 16px;
  position: relative;
}

.menu {
  bottom: 0;
  height: 24px;
  left: 16px;
  margin: auto 0;
  position: absolute;
  top: 0;
}

.title {
  text-align: center;
}

.right {
  position: absolute;
  right: 6px;

  .download {
    font-size: 15px;
    &::before {
      background: var(--border-color);
      bottom: 0;
      content: '';
      display: inline-block;
      height: 32px;
      left: 0;
      margin: auto 0;
      position: absolute;
      top: 0;
      width: 1px;
    }
  }
}
</style>
